export const passwordRules = () => [
  v => !!v || "Password is required.",
  v => (v?.length || 0) >= 12 || "Password must be at least 12 character length.",
  v =>
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)./.test(v) ||
    "Password must contain at least one lowercase letter, one uppercase and one symbol.",
];

export const passwordConfirmRules = valueFn => [v => v === valueFn() || "Passwords must match."];
